angular.module('rjmNg.controllers').controller 'rawExportCtrl', [
  "$rootScope"
  "$scope"
  "$timeout"
  "$http"
  "$q"
  "app"
  "Export"
  "encodedLetterString"
  "$url"
  "restrictionSetService"
  "figureService"
  "rjqlFormula"
  "dateService"
  "StructureCache"
  (
    $rootScope,
    $scope,
    $timeout,
    $http,
    $q,
    app,
    Export,
    encodedLetterString,
    $url,
    restrictionSetService,
    figureService,
    rjqlFormula,
    dateService,
    StructureCache
  ) ->

    $scope.showExportList = false

    # Extracts and formats figure's time range data
    getTimeFrameFromFigure = (figure) ->
      start = null
      end = null

      timeRange = figureService.getTimeRangeFromFigure figure
      timeRangeType = dateService.identifyTimeRange timeRange

      if timeRangeType is 'Static'
        start = if timeRange.start?.datetime? then moment(timeRange.start.datetime).format('YYYY-MM-DD HH:mm:ss') else null
        end = if timeRange.end?.datetime? then moment(timeRange.end.datetime).add(1,'days').format('YYYY-MM-DD HH:mm:ss') else null
      else if timeRangeType is 'Moving'
        start = moment().startOf(timeRange.start.unit).add(timeRange.start.value + 1, timeRange.start.unit).format('YYYY-MM-DD HH:mm:ss')
        end = moment().startOf(timeRange.end.unit).add(timeRange.end.value + 1, timeRange.end.unit).format('YYYY-MM-DD HH:mm:ss')

      start: start
      end: end

    # Extracts and formats figure's filters/group-bys
    getRestrictionSetFromFigure = (figure) ->
      restrictions = figureService.getFiltersFromFigure(figure, true)
      restrictionSet =
        restrictions: restrictions[0]?.restrictions ? []
        sequence:
          string: rjqlFormula.convertPrefixArrayToInfixString(restrictions[0]?.sequence?.string) ? null

      # Group-bys need to be converted to proper filter alias
      filterIndex = 0
      restrictionSet.sequence.string = restrictionSet.sequence.string.replace(/\[.*?\]/g, (match) ->
        returnStr = match
        if match.indexOf('GROUPBYFILTER') > -1
          returnStr = encodedLetterString.indexToAlpha(filterIndex)
        filterIndex++
        return returnStr
      )
      return restrictionSet

    populateFromFigure = (figure) ->
      if not figure?.rjqlId? or not figure?.query?
        return
      now = new Date()
      $scope.exportName = "Raw Data from '#{figure.name}' #{now.toLocaleDateString()}"

      metricIds = figureService.getMetricIdsFromFigure(figure)
      if metricIds.length isnt 1
        throw "Cannot create a raw export on a multi-source rjql query."
      $scope.trendId = metricIds[0]
      $scope.trend = _.find($scope.trends, (t) -> t.id is $scope.trendId)

      $scope.chartTimeFrame = getTimeFrameFromFigure figure
      $scope.restrictionSet = getRestrictionSetFromFigure figure
      $scope.categorySelectors = figure.query.select.rows

    populateFromChart = (chart) ->
      now = new Date()
      $scope.exportName = "Raw Data from '#{chart.name}' #{now.toLocaleDateString()}"
      $scope.chartApiConnId = chart.api_conn_id
      $scope.trend = chart.series[0].trend
      $scope.chartTimeFrame =
         start: if chart.timeFrame.start? then moment(chart.timeFrame.start).format('YYYY-MM-DD HH:mm:ss') else null
         end: if chart.timeFrame.end? then moment(chart.timeFrame.end).format('YYYY-MM-DD HH:mm:ss') else null
      #for non specific time ranges we need to move the end date forward 1 day in order for the LESS date filter to make sense
      if chart.timeFrame.end? and chart.timeFrame.type is "SPECIFIC"
        $scope.chartTimeFrame.end = moment(chart.timeFrame.end).add(1, 'days').format('YYYY-MM-DD HH:mm:ss')
      $scope.restrictionSet = angular.copy(chart.series[0].restrictionSet)
      $scope.trendId = chart.series[0].trend.id
      $scope.categorySelectors = chart.series[0].categorySet.categorySelectors

    if $scope.dashboardItem?.chart?
      populateFromChart($scope.dashboardItem.chart)
    else if $scope.dashboardItem?.figure?
      populateFromFigure($scope.dashboardItem.figure)
    else
      $scope.exportName = ""
      $scope.restrictionSet =
        restrictions: []
        sequence:
          string: null

    $scope.filters =
      isFilterValid: true

    updateTable = () ->
      unless $scope.tableId?
        return

      $scope.selectedTable = _($scope.tables).find (table) ->
        table.id is +$scope.tableId
      columnsStaged = []

      # for rjql_service clients we want to exclude calculated columns
      if app.hasFeatureFlag('RJQL_SERVICE_CLIENT')
        $scope.applicableColumns =  $scope.selectedTable.columns.filter (c) ->
          c.type in ["remote_column", "view"]
      else
        $scope.applicableColumns = $scope.selectedTable.columns

      for column in $scope.applicableColumns
        columnsStaged.push
          name: column.name
          column_id: column.id
          datatype: column.old_data_type

      $scope.columns = columnsStaged

    updateColumns = () ->
      $scope.selectedColumns = []
      $scope.availableColumns = []
      for column in $scope.applicableColumns
        $scope.availableColumns.push column
      $scope.restrictionSet.restrictions = []
      $scope.restrictionSet.sequence.string = null

    watchTableId = ->
      $scope.$watch "tableId", (tableId, old) =>
        if +tableId is old or tableId is ""
          return
        updateTable()
        if $scope.dashboardItem? and old is ""
          return
        if $scope.selectedTable?
          updateColumns()

    # Removes any filters that are not appicable because the column we are restricting on is not availble
    # For example a column might not be available because the rjql-service is calculating it on the fly
    removeInvalidFilters = () ->
      initialFilters = angular.copy $scope.restrictionSet.restrictions
      # going from right to left so that we don't have to worry about filters being removed causing indices to be wrong
      for index in [initialFilters.length - 1..0] by -1
        filter = initialFilters[index]
        sidAvailable = _($scope.applicableColumns).find (column) -> 
          column.id is filter.left.column_id
        unless sidAvailable?
          syntaxTree = restrictionSetService.parseSequenceString($scope.restrictionSet.sequence.string)
          cleansedSyntaxTree = restrictionSetService.removeIndexFromSyntaxTree(syntaxTree, index)
          cleansedSeqString = restrictionSetService.syntaxTreeToString(cleansedSyntaxTree)
          $scope.restrictionSet.restrictions.splice(index,1)
          $scope.restrictionSet.sequence.string = cleansedSeqString

    $scope.tables = []
    promise = StructureCache.getStructure()
    if $scope.trendId?
      trendRestrictionPromise = $http.get $url("/client/#{app.getClientId()}/trend/#{$scope.trendId}/restrictions")
      promise = $q.all([promise,trendRestrictionPromise])
    promise.then (response) ->
      if angular.isArray(response)
        $scope.tables = _.values(response[0].tables)
        if response[1]?
          trendResponse = response[1].data
      else
        $scope.tables = _.values(response.tables)
      $timeout () => #used a timeout to wait until the select2 is rendered before setting the tableId model value
        if $scope.dashboardItem?
          if trendResponse?
            trendSids = restrictionSetService.getSidsFromRestrictionSet(trendResponse)
            $scope.restrictionSet = restrictionSetService.joinRestrictionSets($scope.restrictionSet, restrictionSetService.flattenRestrictionSet(trendResponse))
          else
            trendSids = {}
          if $scope.chartTimeFrame.start?
            $scope.restrictionSet.restrictions.push
              left:
                datatype: $scope.trend.timestampColumn.datatype
                column_id: $scope.trend.timestampColumn.sid
                name: $scope.trend.timestampColumn.name
              op: "GREATER_OR_EQUAL"
              right: $scope.chartTimeFrame.start
            nextFormulaVariable = encodedLetterString.indexToAlpha($scope.restrictionSet.restrictions.length - 1)
            $scope.restrictionSet.sequence.string = _addToSequence($scope.restrictionSet.sequence.string, nextFormulaVariable, 'AND')
          if $scope.chartTimeFrame.end?
            $scope.restrictionSet.restrictions.push
              left:
                datatype: $scope.trend.timestampColumn.datatype
                column_id: $scope.trend.timestampColumn.sid
                name: $scope.trend.timestampColumn.name
              op: "LESS"
              right: $scope.chartTimeFrame.end
            nextFormulaVariable = encodedLetterString.indexToAlpha($scope.restrictionSet.restrictions.length - 1)
            $scope.restrictionSet.sequence.string = _addToSequence($scope.restrictionSet.sequence.string, nextFormulaVariable, 'AND')
          $scope.tableId = $scope.trend.tableId
          updateTable()
          removeInvalidFilters()
          for column in $scope.applicableColumns
            restriction = _($scope.restrictionSet.restrictions).find (restriction) ->
              return restriction.left.column_id is column.id
            grouper = _($scope.categorySelectors).find (categorySelector) ->
              if not categorySelector.column?
                return +categorySelector is +column.id
              return categorySelector.column.sid is column.id
            if $scope.trend.operationColumn.sid is column.id or
                $scope.trend.timestampColumn?.sid is column.id or
                restriction? or grouper? or column.is_primary_key or trendSids[column.id]
              $scope.selectedColumns.push column
            else
              $scope.availableColumns.push column

        if $scope.tableItem?
          $scope.tableId = $scope.tableItem.id
          $scope.exportName = $scope.tableItem.exportName
          updateTable()
          updateColumns()

        watchTableId()
        return

    # Add an item to an existing expression
    _addToSequence = (expression, item, operation) ->
      if expression.length is 0
        return item
      else
        return "(#{expression}) #{operation} #{item}"

    $scope.tableId = null
    $scope.selectedTable = null

    $scope.selectedColumns = []
    $scope.availableColumns = []
    $scope.availableTitle = "Available Columns"
    $scope.selectedTitle = "Selected Columns"

    $scope.createExport = ->
      # php export endpoint expects resriction.left.sid
      # rename restriction.left.column_id to restriction.left.sid
      restrictions = $scope.restrictionSet.restrictions.map (r) ->
        newRestriction = angular.copy r
        if r.left?.column_id?
          newRestriction.left.sid = r.left.column_id
          delete newRestriction.left.column_id 
        newRestriction
      restrictionSet = angular.copy $scope.restrictionSet
      restrictionSet.restrictions = restrictions
      
      Export(app.getClientId()).save(
        $scope.exportName,
        $scope.tableId,
        restrictionSet,
        #php endpoint expects this format for columns 
        $scope.selectedColumns.map (column) ->
          name: column.name
          sid: column.id
          datatype: column.old_data_type
      )

      if $scope.dashboardItem?
        $rootScope.$broadcast "reportRawExportQueued"
      else
        $rootScope.$broadcast "rawExportQueued"

      $scope.showExportList = true
      $scope.hide()
  ]
